import { Container, ResizeIcon, StyledLabel, StyledTextArea, StyledTextAreaWrapper } from "./TextArea.elements.js";
import { TextAreaErrorContainer } from "./TextAreaErrorContainer.js";
import React from "react";
import { uuidv4 } from "@synthesis/shared-utils";
import { jsx, jsxs } from "react/jsx-runtime";
import { get, useFormContext, useFormState } from "react-hook-form";
//#region src/TextArea/index.tsx
function getResolver(control) {
	return control["_options"]?.resolver;
}
const TextAreaBase = React.memo(({ name, placeholder = "", label, disabled = false, readOnly = false, methods, className, autoFocus, resize = true, onBlur, required = false, rules, rows, ...rest }) => {
	const textareaRef = React.useRef(null);
	const { current: fieldId } = React.useRef(`prefix-${uuidv4()}`);
	const hasResolver = Boolean(getResolver(methods.control));
	const formState = useFormState({
		control: methods.control,
		name
	});
	const error = get(formState.errors, `${name}.message`);
	const { ref: registerRef, onBlur: registerOnBlur, ...registerProps } = methods.register(name, rules);
	return /* @__PURE__ */ jsxs(Container, {
		className,
		children: [
			label && /* @__PURE__ */ jsxs(StyledLabel, {
				disabled,
				htmlFor: fieldId,
				children: [label, required && /* @__PURE__ */ jsx("span", {
					className: "text-red-600",
					children: " *"
				})]
			}),
			/* @__PURE__ */ jsxs(StyledTextAreaWrapper, {
				ref: textareaRef,
				disabled,
				readOnly,
				withError: Boolean(error),
				children: [/* @__PURE__ */ jsx(StyledTextArea, {
					readOnly,
					autoFocus,
					resize,
					placeholder,
					disabled,
					id: fieldId,
					rows,
					required,
					...registerProps,
					...rest,
					ref: (element) => {
						registerRef(element);
					},
					onBlur: (event) => {
						registerOnBlur(event);
						onBlur?.(event);
					}
				}), /* @__PURE__ */ jsx(ResizeIcon, {})]
			}),
			!readOnly && hasResolver && /* @__PURE__ */ jsx(TextAreaErrorContainer, {
				textareaRef,
				control: methods.control,
				name
			})
		]
	});
});
TextAreaBase.displayName = "TextAreaBase";
/**
* Дизайн - https://www.figma.com/file/lixEouzSvWhAf04wpHXkIo/%D0%A0%D0%96%D0%94.-UI-Kit?node-id=417%3A5622
*/
const TextArea = React.memo((props) => {
	const methods = useFormContext();
	return /* @__PURE__ */ jsx(TextAreaBase, {
		...props,
		methods
	});
});
TextArea.displayName = "TextArea";
//#endregion
export { TextArea };

//# sourceMappingURL=index.js.map